'use strict';

const container = document.getElementById('intSurvey'),
    // ID of the initial yes/no Touchpoints survey
    yesNoId = container.dataset.yn,
    // ID of the Touchpoints survey modal
    modalId = container.dataset.modal,
    // Hidden ID of the intended data campaign
    hiddenId = container.dataset.hid,
    // Hidden question number the script will bypass
    hiddenQuestionId = container.dataset.hq,
    // Interrupter survey
    intrptr = document.getElementById('intSurvey');

let modalActive = false,
    pageY = 0;

// Google Tag Manager event tracking
const gtmEvent = (id, type, value) => {
    (window.dataLayer = window.dataLayer || []).push({
        event: 'Touchpoints',
        Touchpoints: {
            'survey id': 'tp-' + id,
            'event type': type,
            response: value
        }
    });
};

const loadScript = (id) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.setAttribute(
            'src',
            `https://touchpoints.app.cloud.gov/touchpoints/${id}.js`
        );
        script.setAttribute('type', 'module');
        script.onload = resolve;
        script.onerror = () =>
            reject(
                new Error(
                    `Failed to load script from https://touchpoints.app.cloud.gov/touchpoints/${id}.js`
                )
            );
        intrptr.append(script);
    });
};

// Assign specific IDs to Touchpoints (unused) hidden inputs
const fixDupe = (id) => {
    const loc = document.getElementById('fba_location_code'),
        dir = document.getElementById('fba_directive'),
        locNew = `fba_location_code-${id}`,
        dirNew = `fba_directive-${id}`;

    loc.id = locNew;
    dir.id = dirNew;
};

// Interrupter scripts
const interrupterScripts = async (ynId, mId, hqId) => {
    // Load the yes/no survey script
    try {
        await loadScript(ynId);
        fixDupe(ynId);

        // Assign hidden ID
        document
            .querySelector(
                `#touchpoints-form-${ynId} form input[name$='answer_02']`
            )
            .setAttribute('value', hiddenId);
    } catch (e) {
        console.log(e);
    }

    // Create Touchpoints modal trigger
    const a = document.createElement('a');
    a.id = modalId;
    a.setAttribute('aria-hidden', true);
    intrptr.appendChild(a);

    // Load the modal survey script
    try {
        await loadScript(mId);
        fixDupe(mId);

        // Fix Touchpoints accessibility
        const modal = document.querySelector(`#touchpoints-form-${mId}`),
            thumbs = document.querySelectorAll('div.big-thumbs');
        thumbs.forEach((question) => {
            question
                .querySelectorAll('svg')
                .forEach((svg) => svg.setAttribute('aria-hidden', 'true'));
        });
        modal.setAttribute('tabindex', '0');
        modal.setAttribute('aria-describedby', `fba-form-title-${modalId}`);
    } catch (e) {
        console.log(e);
    }

    // Track clicks on yes/no buttons in yes/no survey
    document
        .querySelectorAll(
            `#touchpoints-form-${ynId} form button[type='submit']`
        )
        .forEach((btn, i) => {
            btn.setAttribute(
                'aria-label',
                i === 0 ? 'Yes, useful' : 'No, not useful'
            );

            btn.addEventListener('click', () => {
                const btnValue = btn.value,
                    hiddenField = document.querySelector(
                        `#touchpoints-form-${mId} form input[name$='${hqId}'][type='hidden']`
                    );

                // Set modal hidden question value based on yes/no survey selection
                if (hiddenField) hiddenField.setAttribute('value', btnValue);

                // Track submissions of yes/no survey for Google Analytics
                gtmEvent(ynId, 'submit', btnValue);

                // Launch the modal
                document.getElementById(mId).click();
                modalActive = true;
            });
        });

    // Track submissions of modal survey for Google Analytics
    document
        .querySelector(`#fba-modal-${mId} button[type='submit']`)
        .addEventListener('click', () => {
            gtmEvent(mId, 'submit', null);
            container.focus();
        });
};

// Use an intersection observer to track the interrupter coming into view
const surveyInterrupter = (entries) => {
    // Check that there are entries
    if (entries.length > 0) {
        if (entries[0].isIntersecting || entries[0].intersectionRatio > 0) {
            interrupterScripts(yesNoId, modalId, hiddenQuestionId);

            // Disconnect the intersection observer
            intrptrObvs.disconnect();
        }
    }
};

// Intersection observer that will trigger when the interrupter
// is within 2x the height of the viewport
const intrptrObvs = new IntersectionObserver(surveyInterrupter, {
    rootMargin: `100% 0px 100% 0px`
});

// Observe the interrupter element
intrptrObvs.observe(intrptr);

// MutationObserver that will trigger when the body toggles class 'usa-js-modal--active'
const modalObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
        ) {
            const bodyHasModal = mutation.target.classList.contains(
                'usa-js-modal--active'
            );
            if (bodyHasModal && modalActive) {
                pageY = window.scrollY;
                document.body.style = `position: fixed; overflow: hidden; width: 100%; top: -${pageY}px;`;
            } else {
                modalActive = false;
                document.body.style = '';
                scrollTo(0, pageY);
            }
        }
    }
});

// Observe the body element
modalObserver.observe(document.body, {
    attributes: true,
    // Observe 'class'
    attributeFilter: ['class']
});






